import { createImagesApi } from '@spotim/images';

import { isProdApi } from '../../config/is-prod-api';

export const images = createImagesApi({ isProduction: isProdApi, optimizedUpload: false });
